import React from "react";
import { object, array, number, string, bool } from "prop-types";

import { Link } from "@quintype/components";
import CardImage from "../../atoms/cardimage";
import Headline from "../../atoms/headline";
import StoryDate from "../../atoms/story-date";

import "./story-card5.m.css";

const StoryCard5 = ({ story, aspectRatio, imageType, headerType, headerLevel, lineClamp, bigCard }) => {
  const widths = bigCard ? [400, 700] : [400];
  return (
    <div className="story-card story-card-5" styleName="story-card-5" id="story-card-5">
      <Link href={`/${story.slug}`}>
        <CardImage
          story={story}
          showVideoIcon
          aspectRatio={aspectRatio}
          imageType={imageType}
          widths={widths}
          sizes="(max-width: 1024px) 20vw, 100vw"
        />
      </Link>
      <Link href={`/${story.slug}`} className="headline-link">
        <Headline
          text={story.headline}
          headerType={headerType}
          headerLevel={headerLevel}
          story={story}
          lineClamp={lineClamp}
        />
      </Link>

      <Link href={`/${story.slug}`}>
        <span styleName="summary" className="summary line-clamp-2">
          {story?.subheadline
            ? story?.subheadline
            : story.seo && story.seo["meta-description"]
            ? story.seo["meta-description"]
            : null}
        </span>
      </Link>
      <StoryDate story={story} />
    </div>
  );
};

StoryCard5.defaultProps = {
  aspectRatio: [16, 9],
  imageType: "image16x9",
  headerType: 3,
  headerLevel: 3,
  lineClamp: 3,
  bigCard: false
};

StoryCard5.propTypes = {
  story: object.isRequired,
  aspectRatio: array,
  imageType: string,
  headerType: number,
  headerLevel: number,
  lineClamp: number,
  bigCard: bool
};

export default StoryCard5;
